import "bootstrap/js/src/util.js";
import "bootstrap/js/src/button.js";
// import "bootstrap/js/src/carousel.js";
import "bootstrap/js/src/collapse.js";
import "bootstrap/js/src/dropdown.js";
import "bootstrap/js/src/modal.js";
// import "bootstrap/js/src/popover.js";
// import "bootstrap/js/src/scrollspy.js";
import "bootstrap/js/src/tab.js";
// import "bootstrap/js/src/tooltip.js";



// WEBPACK FOOTER //
// ./scripts/autoload/bootstrap.js